<template>
  <div>
    <horizontal-navbar></horizontal-navbar>

    <breadcrumb-slot class="pt-2 pb-2" :items="items" :modal="false"></breadcrumb-slot>

    <div class="pt-1 pb-3 d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column align-items-start">
        <h2 class="text-dark">
          {{ index_patient_info.firstName }} {{ index_patient_info.lastName }}
          <small> {{ new Date(index_patient_info.createDate).toLocaleString() }}</small>
        </h2>
        <p v-if="index_patient_info.creatorUser">
          დაამატა: {{ index_patient_info.creatorUser.firstName }} {{ index_patient_info.creatorUser.lastName }}
        </p>
      </div>

      <b-button variant="flat-danger" class="" @click="deletePatient($route.params.id)">
        <feather-icon icon="Trash2Icon"
                      class="mr-50"/>
        <span class="align-middle">პაციენტის წაშლა</span>
      </b-button>
    </div>

    <b-card class="about-patient-container">
      <div class="table-header d-flex align-items-center justify-content-between">
        <h3 class="text-dark mb-0">პაციენტის შესახებ</h3>

        <div class="d-flex justify-content-end">
          <b-button v-if="role !== 'epidemiologist'" variant="secondary" class="btn-icon mr-1" @click="editProfile">
            <feather-icon icon="Edit3Icon"/>
          </b-button>
          <b-button variant="secondary" class="toggle-button btn-icon" @click="togglePatientInfo">
            <feather-icon :class="{'rotate': !patientInfoVisible}" icon="ChevronUpIcon"/>
          </b-button>
        </div>

      </div>

      <div class="infos pt-2 mt-2" v-if="patientInfoVisible">
        <div class="info-container">
          <span>პირადი ნომერი:</span>
          <span><strong>{{ index_patient_info.identityNumber }}</strong></span>
        </div>

        <div class="info-container">
          <span>სქესი:</span>
          <span><strong>{{ indexPatientGender }}</strong></span>
        </div>

        <div class="info-container">
          <span>ტელეფონის ნომერი:</span>
          <span><strong>{{ index_patient_info.phoneNumber }}</strong></span>
        </div>

        <div class="info-container">
          <span>დაბადების თარიღი:</span>
          <span><strong>{{ formatDate(index_patient_info.birthDate) }}</strong></span>
        </div>

        <div class="info-container">
          <span>ასაკი:</span>
          <span><strong>{{ index_patient_info.age }}</strong></span>
        </div>

        <div class="info-container">
          <span>ალტერნატიული ტელ. ნომერი:</span>
          <span><strong>{{ index_patient_info.alternamePhoneNumber }}</strong></span>
        </div>

        <div class="info-container">
          <span>რეგიონი:</span>
          <span><strong>{{ index_patient_info.address.region }}</strong></span>
        </div>

        <div class="info-container">
          <span>მისამართი:</span>
          <span><strong>{{ index_patient_info.address.address }}</strong></span>
        </div>

        <div class="info-container">
          <span>ქალაქი/რაიონი:</span>
          <span><strong>{{ index_patient_info.address.city }}</strong></span>
        </div>
      </div>

    </b-card>

    <b-card class="current-case-container">
      <div class="table-header d-flex align-items-center justify-content-between">
        <h3 class="text-dark mb-0">მიმდინარე შემთხვევა</h3>

        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="btn-icon mr-1" @click="$refs['history-modal'].show()">
            <feather-icon icon="ClockIcon" class="mr-1"/>
            <span>შემთხვევების ისტორია</span>
          </b-button>
          <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleCurrentCase">
            <feather-icon :class="{'rotate': !currentCaseVisible}" icon="ChevronUpIcon"/>
          </b-button>
        </div>
      </div>

      <div v-if="currentCaseVisible" class="current-case pt-2 mt-2">
        <div class="info-container">
          <span>ტუბ. შემთხვევის კოდი:</span>
          <span class="d-flex align-items-start">
            <strong>{{ index_patient_current_cases.code }}</strong>
          </span>

        </div>

        <div class="info-container">
          <span>შემთხვევის დეფინიცია:</span>
          <span><strong>{{ index_patient_current_cases.definition }}</strong></span>
        </div>

        <div class="info-container">
          <span>დიაგნოზის დასმის თარიღი:</span>
          <span v-if="index_patient_current_cases.diagnoseDate">
            <strong>{{ formatDate(index_patient_current_cases.diagnoseDate) }}</strong>
          </span>
        </div>

        <div class="info-container">
          <span>ტუბერკულოზის ლოკალიზაცია:</span>
          <span><strong>{{ index_patient_current_cases.tbLocalization }}</strong></span>
        </div>

        <div class="info-container">
          <span>მკურნალობის დაწყების თარიღი:</span>
          <span v-if="index_patient_info.treatmentStartDate">
            <strong>{{ formatDate(index_patient_info.treatmentStartDate) }}</strong>
          </span>
        </div>

        <div class="info-container">
          <span>ახლო კონტაქტების რაოდენობა:</span>
          <span><strong>{{ index_patient_info.closeContactCount }}</strong></span>
        </div>

        <div class="info-container">
          <span>რეზისტენტობა:</span>
          <span><strong>{{ index_patient_info.resistance }}</strong></span>
        </div>

        <div class="info-container">
          <span>ოჯახური კონტაქტების რაოდენობა:</span>
          <span><strong>{{ index_patient_info.familyMemberCount }}</strong></span>
        </div>

        <div class="info-container">
          <span>MGB Status:</span>
          <span><strong>{{ index_patient_current_cases.mgbStatus }}</strong></span>
        </div>

        <div class="info-container">
          <span>ჯინექსპერტი:</span>
          <span><strong>{{ index_patient_current_cases.ginExpert }}</strong></span>
        </div>

        <div class="info-container">
          <span>გულმკერდის რენტგენი:</span>
          <span><strong>{{ index_patient_current_cases.chestXRay }}</strong></span>
        </div>
      </div>

      <div v-if="currentCaseVisible" class="info-container symptoms d-flex mt-2">
        <span>პირველადი სიმპტომები:</span>
        <span><strong>{{ index_patient_current_cases.mgbStatus }}</strong></span>
      </div>


    </b-card>

    <b-card class="">
      <div class="table-header d-flex align-items-center justify-content-between">
        <h3 class="text-dark mb-0">კონტაქტები</h3>

        <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleIndexContacts">
          <feather-icon :class="{'rotate': !indexContactsVisible}" icon="ChevronUpIcon"/>
        </b-button>
      </div>
      <table-basic-patients v-if="indexContactsVisible" :rows="index_patient_contacts"
                            emptyText="კონტაქტები არ არის დამატებული"
                            :columns="columns" :paging="false" @redirect="redirectToProfile"
                            class-name="patient-container">
      </table-basic-patients>
    </b-card>

    <b-card class="">
      <div class="table-header d-flex align-items-center justify-content-between">
        <h3 class="text-dark mb-0">პასუხისმგებელი პირი და დაწესებულებები</h3>

        <div class="d-flex justify-content-end">
          <b-button v-if="role !== 'epidemiologist'" variant="secondary" class="btn-icon mr-1" @click="addInstitution">
            <feather-icon icon="PlusIcon"/>
          </b-button>
          <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleResponsiblePerson">
            <feather-icon :class="{'rotate': !responsiblePersonVisible}" icon="ChevronUpIcon"/>
          </b-button>
        </div>
      </div>

      <div v-if="responsiblePersonVisible" class="responsibility-container pt-2 pb-2">
        <div class="info-container">
          <span>პაციენტი დაარეგისტრირა:</span>
          <span><strong>{{ index_patient_info.responsiblePerson }}</strong></span>
        </div>
        <div class="info-container d-flex row institutions">
          <span>პროფილზე წვდომის მქონე დაწესებულებები:</span>
          <div class="badges pt-1">
            <b-badge v-for="institution in index_patient_info.institutions" v-bind:key="institution.id"
                     class="badge-light-dark p-1 mr-1 mt-1">{{ institution.title }}
            </b-badge>
          </div>
        </div>
      </div>
    </b-card>

    <b-modal id="modal-edit"
             ref="my-modal"
             size="lg"
             class="p-3"
             hide-footer
             hide-header
             centered>

      <div class="pt-2 modal-custom-header d-flex align-items-center justify-content-between">
        <h4></h4>
        <b-button variant="flat-secondary" class="btn-icon" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <validation-observer ref="editIndexPatient" #default="{invalid}">

        <b-form>

          <div class="d-flex justify-content-between">
            <b-form-group class="name-wrapper mb-2 mt-2 w-75">
              <label for="name">სახელი და გვარი</label>
              <b-input-group class="input-group-merge">
                <validation-provider
                    class="pr-2"
                    #default="{ errors }"
                    name="firstname"
                    vid="firstname"
                    rules="required">
                  <b-form-input class="mr-1"
                                :class="{'btn-outline-success': editingName}"
                                v-model="name"
                                id="name"
                                placeholder="სახელი"
                                type="text"></b-form-input>
                  <small class="text-danger pl-1">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                    class="w-50"
                    #default="{ errors }"
                    name="lastname"
                    vid="surname"
                    rules="required">
                  <b-form-input
                      :class="{'btn-outline-success': editingName}"
                      v-model="surname"
                      id="surname"
                      placeholder="გვარი"
                      type="text"></b-form-input>
                  <small class="text-danger pl-1">{{ errors[0] }}</small>
                </validation-provider>
              </b-input-group>
            </b-form-group>
          </div>

          <template>
            <div class="edit-patient d-flex row justify-content-between">
              <b-form-group label="პირადი ნომერი *"
                            label-for="id">
                <validation-provider
                    #default="{ errors }"
                    name="identity number"
                    vid="id"
                    rules="required|digits:11">
                  <b-form-input id="id" v-model="identityNumber"
                                placeholder="პირადი ნომერი"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="დაბადების თარიღი *"
                            label-for="birthDate">
                <flat-pickr
                    class="form-control"
                    v-model="birthDate"
                    :value="birthDate"
                    :config="{allowInput: true}"
                />
              </b-form-group>
              <b-form-group label="ტელეფონის ნომერი *"
                            label-for="phone">
                <b-form-input id="phone" v-model="phone"
                              placeholder="ტელეფონის ნომერი"/>
              </b-form-group>
              <b-form-group label="რეგიონი *"
                            label-for="region">
                <b-form-select v-model="selectedRegion"
                               :options="regions"/>
              </b-form-group>
              <b-form-group label="ალტერნატიული ტელეფონის ნომერი"
                            label-for="phone">
                <b-form-input id="alternatePhoneNumber" v-model="alternatePhoneNumber"
                              placeholder="ალტერნატიული ტელეფონის ნომერი"/>
              </b-form-group>
              <b-form-group label="ქალაქი/სოფელი *"
                            label-for="city">
                <b-form-input id="city" v-model="city"
                              placeholder="ქალაქი/სოფელი"/>
              </b-form-group>
              <b-form-group label="სქესი *"
                            label-for="gender">
                <b-form-select id="gender" v-model="selectedGender"
                               :options="genderOptions"/>
              </b-form-group>
              <b-form-group label="მისამართი *"
                            label-for="address">
                <b-form-input id="address" v-model="address"
                              placeholder="მისამართი"/>
              </b-form-group>
            </div>
          </template>

          <template>
            <div class="divider my-2">
              <div class="divider-text">პასუხისმგებელი პირი და დაწესებულებები</div>
            </div>
            <div>
              <b-form-group label="პასუხისმგებელი პირი *"
                            label-for="responsiblePerson">
                <b-form-input id="responsiblePerson" v-model="responsiblePerson"
                              placeholder="პასუხისმგებელი პირი"/>
              </b-form-group>
              <b-form-group label="დაწესებულებები" v-if="institutions.length">
                <multiselect v-model="chosenInstitutions" tag-placeholder="საძიებო სიტყვა"
                             placeholder="ძიება" label="text" track-by="value"
                             :options="institutions" :multiple="true" :taggable="true"></multiselect>
              </b-form-group>
            </div>
          </template>

          <template>
            <div class="divider my-2">
              <div class="divider-text">მიმდინარე შემთხვევა</div>
            </div>
            <b-form-group label="ტუბ. შემთხვევის კოდი *"
                          label-for="code">
              <validation-provider
                  #default="{ errors }"
                  name="code"
                  vid="code"
                  rules="required">
                <b-form-input class="mr-1"
                              v-model="code"
                              id="code"
                              placeholder="კოდი"
                              type="text"></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>

              </validation-provider>
            </b-form-group>

          </template>

          <div class="mt-3 d-flex justify-content-between align-items-center">

            <b-button :disabled="invalid" variant="primary" class="save-changes mb-3" @click="updateProfile">
              <feather-icon icon="SaveIcon"
                            class="mr-50"/>
              <span class="align-middle">ცვლილებების შენახვა</span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-history"
             ref="history-modal"
             size="lg"
             class="p-3"
             hide-footer
             hide-header
             centered>
      <div class="pt-2 pb-2 modal-custom-header d-flex align-items-center justify-content-between">
        <h4>შემთხვევების ისტორია</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <div v-for="history in cases" v-bind:key="history.id" class="cases-container pb-3">
        <p><strong>წარსული შემთხვევა</strong></p>

        <div class="current-case">
          <div class="info-container">
            <span>ტუბ. შემთხვევის კოდი:</span>
            <span><strong>{{ history.code }}</strong></span>
          </div>

          <div class="info-container">
            <span>შემთხვევის დეფინიცია:</span>
            <span><strong>{{ history.definition }}</strong></span>
          </div>

          <div class="info-container">
            <span>დიაგნოზის დასმის თარიღი:</span>
            <span><strong>{{ formatDate(history.diagnoseDate) }}</strong></span>
          </div>

          <div class="info-container">
            <span>ტუბერკულოზის ლოკალიზაცია:</span>
            <span><strong>{{ history.tbLocalization }}</strong></span>
          </div>
        </div>

        <div class="info-container symptoms d-flex pb-2 mt-2">
          <span>პირველადი სიმპტომები:</span>
          <div class="badges pt-1">
            <b-badge v-for="symptom in history.symptoms" v-bind:key="symptom"
                     class="badge-light-dark p-1">
              {{ symptom }}
            </b-badge>
          </div>
        </div>

        <div>
          <p>კონტაქტები:</p>

          <b-table responsive="sm"
                   :fields="['name', 'contact_type']"
                   outlined
                   show-empty
                   empty-text="ვარიანტები არ არის დამატებული"
                   :items="case_contacts">

            <template #cell(name)="data" td-class="text-right">
              <span>{{ data.item.firstName }} {{ data.item.lastName }}</span>
            </template>
            <template #cell(contact_type)="data" td-class="text-right">
              <span>{{ data.item.relationType }}</span>
            </template>
          </b-table>
        </div>

      </div>

    </b-modal>

    <b-modal id="modal-institutions"
             ref="institutions"
             size="lg"
             class="p-3"
             hide-footer
             hide-header
             centered>
      <div class="pt-2 pb-2 modal-custom-header d-flex align-items-center justify-content-between">
        <h4>დაწესებულებები</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>
      <div class="mb-3 mt-1" v-if="institutions.length">
        <multiselect v-model="chosenInstitutions" tag-placeholder="საძიებო სიტყვა"
                     placeholder="დაწესებულება" label="text" track-by="value"
                     :options="institutions" :multiple="true" :taggable="true"></multiselect>
      </div>

      <div class="pt-2 pb-2 modal-custom-header d-flex align-items-center justify-content-between">
        <div></div>
        <b-button variant="primary" class="btn-icon mr-1" size="md" @click="updateProfile">
          <feather-icon icon="PlusIcon" class="mr-1"/>
          <span>დამატება</span>
        </b-button>
      </div>

    </b-modal>

  </div>
</template>

<script>
import BreadcrumbSlot from "../../components/breadcrumb/BreadcrumbSlot";
import flatPickr from "vue-flatpickr-component"
import {
  BButton,
  BCard,
  BBadge,
  BInputGroup,
  BFormGroup,
  BForm,
  BModal,
  BTable,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue"
import TableBasicPatients from "../../table/bs-table/TableBasicPatients";
import modulePatients from "../../../store/patient/modulePatients"
import moduleRegions from "../../../store/regions/moduleRegions"
import moduleInstitutions from "../../../store/institution/moduleInstitution"
import HorizontalNavbar from "../../navbar/HorizontalNavbar";
import Multiselect from "vue-multiselect"
import {ValidationProvider, ValidationObserver} from "vee-validate"
import {required, digits} from "@validations"

export default {
  name: "IndexPatientProfile",
  components: {
    HorizontalNavbar,
    TableBasicPatients,
    BreadcrumbSlot,
    BCard,
    BBadge,
    BButton,
    BInputGroup,
    BFormGroup,
    BForm,
    BModal,
    BTable,
    BFormInput,
    flatPickr,
    BFormSelect,
    Multiselect,
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      // validation rules
      required,
      digits,

      chosenInstitutions: [],
      items: [
        {
          text: "ინდექს პაციენტები",
          link: "index-patients",
          active: false
        },
        {
          text: "",
          active: true,
        }
      ],
      columns: [
        {
          key: "name",
          label: "სახელი",
          sortable: true
        },
        {
          key: "type",
          label: "კონტაქტის ტიპი",
          sortable: false
        },
        {
          key: "status",
          label: "სიმპტომები",
          sortable: false,
        },
        {
          key: "treatment",
          label: "მკურნალობა",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
        },
      ],
      editingName: false,
      name: "",
      surname: "",
      age: "",
      city: "",
      address: "",
      phone: "",
      alternatePhoneNumber: "",
      identityNumber: "",
      case: "",
      code: "",
      responsiblePerson: "",
      institutionIds: [],
      selectedRegion: null,
      selectedGender: null,

      genderOptions: [
        {value: null, text: "აირჩიეთ სქესი"},
        {value: "Male", text: "მამრობითი"},
        {value: "Female", text: "მდედრობითი"},
        {value: "Other", text: "სხვა"},
      ],

      birthDate: null,

      date: null,
      config: {
        altFormat: "F j, Y",
        altInput: true
      },

      months: {
        0: "იანვარი",
        1: "თებერვალი",
        2: "მარტი",
        3: "აპრილი",
        4: "მაისი",
        5: "ივნისი",
        6: "ივლისი",
        7: "აგვისტო",
        8: "სექტემბერი",
        9: "ოქტომბერი",
        10: "ნოემბერო",
        11: "დეკემბერი"
      },

      case_contacts: [
        {
          name: "ჯონათან ლივინსგტონი",
          contact_type: "მეუღლე"
        }
      ],

      patientInfoVisible: true,
      currentCaseVisible: true,
      indexContactsVisible: true,
      responsiblePersonVisible: true,
    }
  },

  computed: {

    index_patient_info() {
      return this.$store.state.patients.index_patient_info
    },

    index_patient_current_cases() {
      return this.$store.state.patients.index_patient_current_cases
    },

    index_patient_contacts() {
      return this.$store.state.patients.index_patient_contacts.length > 0 ? this.$store.state.patients.index_patient_contacts : []
    },

    regions() {
      return this.$store.state.regions.regions
    },

    institutions() {
      return this.$store.state.institution.institutions
    },

    indexPatientGender() {
      let gender = this.genderOptions.find(a => a.value === this.index_patient_info.gender)
      return gender ? gender.text : ""
    },

    cases() {
      return this.$store.state.patients.cases
    },

    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },

    role() {
      let roles = this.userInfo["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
      if (typeof roles === "object") {
        return roles[0]
      }
      return roles
    }
  },

  created() {
    this.onCreated();
  },

  mounted() {
    this.navItems = document.getElementsByClassName("nav-item");
    this.navItems[18].classList.add("active");
  },

  watch: {
    "$route.params": {
      handler() {
        this.onCreated();
      },
    }
  },

  methods: {

    onCreated() {
      if (!modulePatients.isRegistered) {
        this.$store.registerModule("patients", modulePatients);
        modulePatients.isRegistered = true
      }

      if (!moduleRegions.isRegistered) {
        this.$store.registerModule("regions", moduleRegions);
        moduleRegions.isRegistered = true
      }

      if (!moduleInstitutions.isRegistered) {
        this.$store.registerModule("institution", moduleInstitutions);
        moduleInstitutions.isRegistered = true
      }

      this.getIndexPatientInfo(this.$route.params.id).then(() => {
        this.items[1].text = this.index_patient_info.firstName + " " + this.index_patient_info.lastName
        this.chosenInstitutions = this.index_patient_info.institutions.map(item => {
          return {
            text: item.title,
            value: item.id
          }
        })
      });

      this.getIndexPatientCurrentCases(this.$route.params.id);

      this.getIndexPatientContacts(this.$route.params.id);

      this.getRegions();

      this.getPatientCases(this.$route.params.id);
    },

    getIndexPatientInfo(id) {
      return this.$store.dispatch("patients/getIndexPatientInfo", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getPatientCases(id) {
      return this.$store.dispatch("patients/getPatientCases", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    updateIndexPatientInfo(payload) {
      return this.$store.dispatch("patients/updateIndexPatientInfo", payload).then(() => {
        this.getIndexPatientInfo(this.$route.params.id);
        this.getIndexPatientCurrentCases(this.$route.params.id);
        this.hideModal();
      }).catch((err) => {
      });
    },

    getIndexPatientCurrentCases(id) {
      return this.$store.dispatch("patients/getIndexPatientCurrentCases", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getIndexPatientContacts(id) {
      return this.$store.dispatch("patients/getIndexPatientContacts", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    deletePatient(id) {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("patients/deletePatient", id).then(() => {
            this.$router.push({name: "index-patients"})
          }).catch((err) => {
          });
        }
      });
    },

    getRegions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("regions/getRegions", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getInstitutions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("institution/getInstitutions", payload).then((response) => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    openEditCodeModal() {
      this.code = this.index_patient_current_cases.code
      this.$refs["edit-code"].show()
    },

    updateProfile() {
      this.fillProfileInfo()
      let profile = {
        "id": this.$route.params.id,
        "birthDate": new Date(this.birthDate),
        "age": this.age,
        "gender": this.selectedGender,
        "firstName": this.name,
        "lastName": this.surname,
        "identityNumber": this.identityNumber,
        "phoneNumber": this.phone,
        "alternamePhoneNumber": this.alternatePhoneNumber,
        "responsiblePerson": this.responsiblePerson,
        "address": {
          "city": this.city,
          "address": this.address,
          "id": this.index_patient_info.address.id,
          "regionId": this.selectedRegion
        },
        "institutionIds": this.chosenInstitutions.map(el => el.value),
        "case": {
          "id": this.index_patient_current_cases.id,
          "code": this.code,
          "diagnoseDate": this.index_patient_current_cases.diagnoseDate,
          "treatmentStartDate": this.index_patient_current_cases.treatmentStartDate,
          "definition": this.index_patient_current_cases.definition,
          "mgbStatus": this.index_patient_current_cases.mgbStatus,
          "resistance": this.index_patient_current_cases.resistance,
          "tbLocalization": this.index_patient_current_cases.tbLocalization,
          "symptoms": this.index_patient_current_cases.symptoms,
          "contacts": this.index_patient_current_cases.contacts,
          "familyMemberCount": this.index_patient_info.familyMemberCount,
          "closeContactCount": this.index_patient_info.closeContactCount,
        }
      };

      this.updateIndexPatientInfo(profile);
    },

    fillProfileInfo() {
      this.name = this.name ? this.name : this.index_patient_info.firstName;
      this.surname = this.surname ? this.surname : this.index_patient_info.lastName;
      this.age = this.age ? this.age : this.index_patient_info.age;
      this.city = this.city ? this.city : this.index_patient_info.address.city;
      this.address = this.address ? this.address : this.index_patient_info.address.address;
      this.phone = this.phone ? this.phone : this.index_patient_info.phoneNumber;
      this.alternatePhoneNumber = this.alternatePhoneNumber ? this.alternatePhoneNumber : this.index_patient_info.alternamePhoneNumber;
      this.responsiblePerson = this.responsiblePerson ? this.responsiblePerson : this.index_patient_info.responsiblePerson;
      this.birthDate = this.birthDate ? this.birthDate : this.index_patient_info.birthDate;
      this.selectedGender = this.selectedGender ? this.selectedGender : this.index_patient_info.gender;
      this.selectedRegion = this.selectedRegion ? this.selectedRegion : this.index_patient_info.address.regionId;
      this.identityNumber = this.identityNumber ? this.identityNumber : this.index_patient_info.identityNumber;
      this.code = this.code ? this.code : this.index_patient_current_cases.code;
    },

    editProfile() {
      this.fillProfileInfo()
      this.$refs["my-modal"].show()
    },

    addInstitution() {
      this.getInstitutions({take: -1, skip: 0}).then(() => {
        this.index_patient_info.institutions.forEach(item => {
          this.chosenInstitutions.push({
            text: item.title,
            value: item.id
          })
        })
        console.log(this.chosenInstitutions)
      })
      this.$refs["institutions"].show()
    },

    redirectToProfile(value) {
      if (value.currentPatientType === "Index") {
        this.$router.push({
          name: "index-patient-profile",
          params: {id: value.id}
        });
      } else {
        this.$router.push({name: "contact-profile", params: {id: value.id}})
      }
    },

    formatDate(date) {
      if (date) {
        let d = new Date(date);
        let day = d.getDate();
        let monthName = this.months[d.getMonth()];
        let year = d.getFullYear();
        return `${day} ${monthName}, ${year}`;
      }
      return ""
    },

    hideModal() {
      this.$refs["my-modal"].hide();
      this.$refs["history-modal"].hide();
      this.$refs["institutions"].hide();
      this.$refs["edit-code"].hide()
    },

    togglePatientInfo() {
      this.patientInfoVisible = !this.patientInfoVisible
    },

    toggleCurrentCase() {
      this.currentCaseVisible = !this.currentCaseVisible
    },

    toggleIndexContacts() {
      this.indexContactsVisible = !this.indexContactsVisible
    },

    toggleResponsiblePerson() {
      this.responsiblePersonVisible = !this.responsiblePersonVisible
    },
  },

  destroyed() {
    this.navItems[18].classList.remove("active");
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.flatpickr-current-month .flatpickr-monthDropdown-months span, .flatpickr-current-month .numInputWrapper span {
  display: block;
}

.flatpickr-months .flatpickr-month {
  user-select: text !important;
}

.toggle-button {
  svg {
    transition: 0.2s all ease;
  }

  .rotate {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.save-changes.btn span {
  font-size: 16px;
}

.form-group label {
  font-size: 1.057rem;
}

.modal-custom-header h4 {
  font-size: 20px;
}

.infos {
  display: grid;
  grid-template-columns: 2fr 2fr 3fr;
  grid-gap: 10px;
}

.current-case {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.responsibility-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
}

.symptoms.info-container {
  height: auto;
  flex-direction: column;
}

.current-case {
  .info-container {
    height: 3.5vh;
  }
}

.info-container {
  height: 3.5vh;
  margin-right: 2vw;
  display: grid;
  grid-template-columns: 1fr 1fr;

  span {
    margin-right: 10px;
    line-height: 1.1;
  }

  &.institutions {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
  }
}

.edit-patient {
  margin: 0 !important;

  .form-group {
    width: 45%;
  }
}

#modal-edit {
  .modal-body {
    padding: 0.8rem 4rem;
  }
}

.save-changes {
  width: 100%;
}

.name-wrapper input, .name-wrapper button {
  border: none !important;
  border-bottom: 1px solid #d8d6de !important;
  border-radius: 0;
}

#modal-history .info-container span {
  white-space: nowrap;
}

@media only screen and (max-width: 1550px) {

  .infos {
    grid-template-columns: 2fr 2fr;
  }

  .info-container {
    //height: 4.5vh;

    span {
      line-height: 1.1;

    }
  }
}

</style>
